import React from "react";

import BodyText from "core/BodyText";
import ArrowLongRight from "core/ReusableIcons/ArrowLongRight";

import { IconsDashboardLinkContainer } from "./styles";
import colors from "core/colors";
import { PHOTO_SUBMISSIONS_FLAG } from "frontend/data/featureFlags";

import useFeatureFlag from "frontend/hooks/useFeatureFlag";

const IconsDashboardLink = () => {
    const hasPhotoSubmissionsAccess = useFeatureFlag(PHOTO_SUBMISSIONS_FLAG);

    if (!hasPhotoSubmissionsAccess) return null;

    return (
        <IconsDashboardLinkContainer href="/dashboard/">
            <BodyText size="sm" copyColor={colors.accent.lightMode.persian}>
                Go to icons dashboard
            </BodyText>
            <ArrowLongRight size="md" />
        </IconsDashboardLinkContainer>
    );
};

export default IconsDashboardLink;
